module.exports = __webpack_public_path__ + "static/media/orange.23bef400.png";